module.exports = __webpack_public_path__ + "img/bg-logo.64516d47.png";